import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../AppIcon';
import useNetworkStatus from '../../hooks/useNetworkStatus';
import { useToast } from '../context/ToastContext';

const OfflineBanner = () => {
  const isOnline        = useNetworkStatus();
  const { addToast }    = useToast();
  const hasBeenOffline  = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      hasBeenOffline.current = true;
    } else if (hasBeenOffline.current) {
      hasBeenOffline.current = false;
      addToast("You're back online", 'success');
    }
  }, [isOnline]);

  return (
    <div className="fixed bottom-6 left-0 right-0 flex justify-center z-[300] pointer-events-none">
      <AnimatePresence>
        {!isOnline && (
          <motion.div
            key="offline-banner"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            className="pointer-events-auto flex items-center gap-3 px-5 py-3 rounded-full shadow-2xl whitespace-nowrap"
            style={{
              background: '#0f0f0f',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
            }}
          >
            {/* Pulsing red dot */}
            <span className="relative flex h-2 w-2 flex-shrink-0">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
            </span>

            <Icon name="WifiOff" size={15} color="rgba(255,255,255,0.75)" />

            <span className="text-sm font-medium font-caption">
              No internet connection
            </span>

            <span className="text-xs font-caption" style={{ color: 'rgba(255,255,255,0.4)' }}>
              · Your changes may not save
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default OfflineBanner;
